// extracted by mini-css-extract-plugin
module.exports = {"heart":"favoirtefn_heart_H8NO-","iconinner":"favoirtefn_iconinner_3YpyK","iconstyle":"favoirtefn_iconstyle_15trX","iconsizelike":"favoirtefn_iconsizelike_3gLIn"};